import { jsx as a } from "react/jsx-runtime";
import { useRef as d, useLayoutEffect as b } from "react";
import h from "classnames";
import i from "./index.es5647.js";
import { Skeleton as k } from "./index.es65.js";
const N = ({
  testId: m = "skeleton-cell",
  isVisible: u = !0,
  children: c,
  align: p = "left"
}) => {
  const t = d(null), f = h(i.skeletonCellRoot, i[p]);
  return b(() => {
    var e, r, o, l, s, n;
    (r = (e = t.current) == null ? void 0 : e.parentElement) == null || r.setAttribute("aria-busy", "true"), (l = (o = t.current) == null ? void 0 : o.parentElement) == null || l.setAttribute("role", "status"), (n = (s = t.current) == null ? void 0 : s.parentElement) == null || n.setAttribute("aria-live", "polite");
  }, []), /* @__PURE__ */ a("div", { className: f, "data-testid": m + "-container", ref: t, children: /* @__PURE__ */ a(k, { isVisible: u, height: "16px", width: "90px", children: c }) });
};
export {
  N as SkeletonCell
};
//# sourceMappingURL=index.es5533.js.map
